<mat-toolbar class="subtitulo"><mat-icon>lock</mat-icon></mat-toolbar>

<div fxLayout="column" fxLayoutGap="30px" fxLayoutAlign="center center" >
        <h1>ACESSO RESTRITO</h1>
        <img src="../../../assets/img/cadeado.png" />
</div>

